<!--
Author: Lsc
Date: 2019-07-25
Desc: 修改资料-上传身份证ocr验证
 -->
<template>
    <div class="ocr-upd-modify comp">
        <el-row class="up-list-ocr" :span="24">
            <el-form :model="img">
                <el-form-item label="">
                    <p class="up-list-mes">本人有效身份证正反面照</p>
                    <div class="img-up-box">
                        <div class="img-up-list el-upload-list--picture-card">
                            <div v-if="imgBase64.backImage" class="el-upload-list__item-actions">
                                <i
                                    class="el-icon-zoom-in"
                                    aria-hidden="true"
                                    v-on:click="handlePictureCardPreview('backImage')"
                                />
                                <i
                                    class="el-icon-delete"
                                    aria-hidden="true"
                                    v-on:click="delImg('backImage')"
                                />
                            </div>
                            <el-input
                                v-model="img.backImage"
                                type="file"
                                name="backImage"
                                :accept="accept"
                                v-on:change="getImgBase"
                            />
                            <div class="img-up img-load-status">
                                <img v-if="imgBase64.backImage" :src="imgBase64.backImage" alt="" />
                                <img v-else :src="require('../../assets/img/ocrback.png')" alt="" />
                                <!-- <i v-if="!imgBase64.back" class="el-icon-plus" aria-hidden="true" />
                                <span v-if="!imgBase64.back" class="img-text">身份证反面照</span> -->
                            </div>
                        </div>
                        <div class="img-up-list el-upload-list--picture-card">
                            <div v-if="imgBase64.faceImage" class="el-upload-list__item-actions">
                                <i
                                    class="el-icon-zoom-in"
                                    aria-hidden="true"
                                    v-on:click="handlePictureCardPreview('faceImage')"
                                />
                                <i
                                    class="el-icon-delete"
                                    aria-hidden="true"
                                    v-on:click="delImg('faceImage')"
                                />
                            </div>
                            <el-input
                                v-model="img.faceImage"
                                type="file"
                                name="faceImage"
                                :accept="accept"
                                v-on:change="getImgBase"
                            />
                            <div class="img-up img-load-status">
                                <img v-if="imgBase64.faceImage" :src="imgBase64.faceImage" alt="" />
                                <img v-else :src="require('../../assets/img/ocrover.png')" alt="" />
                                <!-- <i v-if="!imgBase64.faceImage" class="el-icon-plus" aria-hidden="true"/> -->
                                <!-- <span v-if="!imgBase64.faceImage" class="img-text">身份证正面照</span> -->
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="" class="btn-center">
                    <el-button
                        type="primary"
                        class="medium"
                        :disabled="btnStatus"
                        v-on:click="submitInfo()"
                    >
                        上传
                    </el-button>
                    <el-button class="medium" v-on:click="$router.push({ name: 'modifyinfo' })">
                        还未准备好
                    </el-button>
                </el-form-item>
            </el-form>
            <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
        </el-row>
    </div>
</template>
<script>
export default {
    name: "OrcUpdModify",
    data() {
        return {
            dialogImageUrl: "",
            dialogVisible: false,
            accept: "image/bmp,image/png,image/jpg,image/jpeg",
            img: {
                faceImage: "",
                backImage: ""
            },
            imgBase64: {
                faceImage: "",
                backImage: ""
            },
            upload_url: "/acct/ocr/upload"
        };
    },
    computed: {
        btnStatus: function () {
            return !(this.imgBase64.faceImage && this.imgBase64.backImage);
        }
    },
    watch: {},
    methods: {
        handlePictureCardPreview(filename) {
            this.dialogImageUrl = this.imgBase64[filename];
            this.dialogVisible = true;
        },
        submitInfo() {
            const _this = this;
            const _x = this.$util.src(_this.upload_url, {}, true);
            const _data = {
                // 修改正反面字段
                // faceImage: _this.imgBase64.faceImage.substring(_this.imgBase64.faceImage.search(",") + 1),
                // backImage: _this.imgBase64.backImage.substring(_this.imgBase64.backImage.search(",") + 1)
                backImage: _this.imgBase64.faceImage.substring(
                    _this.imgBase64.faceImage.search(",") + 1
                ),
                faceImage: _this.imgBase64.backImage.substring(
                    _this.imgBase64.backImage.search(",") + 1
                )
            };
            this.$req({
                method: "POST",
                url: _x,
                timeout: 40000,
                data: _data
            })
                .then((res) => {
                    if (res.code === "0000000") {
                        _this.$cache.refreshUser();
                        const message1 = "上传身份证件成功，";
                        const message2 = "秒后返回信息修改页";
                        this.$handleAutoCloseMessage({
                            type: "success",
                            message1: message1,
                            message2: message2,
                            number: 3,
                            onClose: function () {
                                _this.$router.push({ name: "modifyinfo" });
                            }
                        });
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch(() => {});
        },
        getImgBase() {
            const _this = this;
            const event = window.event;
            const file = event.target && event.target.files[0];
            let k = 0;
            if (!file) {
                this.delImg(event.target.name);
                return false;
            }
            let maxSize = this.$cache.getOcrFileSize();
            if (file.size > 1024 * 1024 * maxSize) {
                this.img[event.target.name] = "";
                this.$message.warning("上传文件大小超过限制大小" + maxSize + "M，不能上传");
                return;
            }
            for (var i in this.img) {
                if (this.img[i] && file.name === this.img[i].split("\\").pop()) k++;
            }
            if (k === 2) {
                this.delImg(event.target.name);
                this.$message.warning("不能上传相同名称的文件，请重新上传");
                return false;
            }
            const reader = new FileReader();
            // 转base64
            reader.onload = function (e) {
                _this.$set(_this.imgBase64, event.target.name, e.target.result);
            };
            reader.readAsDataURL(file);
        },
        // 删除图片
        delImg(index) {
            this.imgBase64[index] = "";
            if (this.img[index]) {
                this.img[index] = "";
            }
        }
    }
};
</script>
<style lang="scss">
.ocr-upd-modify {
    .btn-center {
        text-align: center;
    }
    .up-list-ocr {
        padding: 20px 0;
        .up-list-mes {
            text-align: center;
            font-size: $f22;
            color: $text-color2;
            line-height: 30px;
        }
        .img-up-list {
            margin: 50px 0px;
            display: inline-block;
            position: relative;
            .el-upload-list__item-actions {
                z-index: 100;
                i {
                    font-size: $f24;
                    cursor: pointer;
                }
                i:last-of-type {
                    margin-left: 20px;
                }
            }
            .el-input {
                position: absolute;
                top: 0;
                left: 0;
                opacity: 0;
                z-index: 10;
            }
            .img-up,
            .el-input .el-input__inner {
                width: 320px;
                height: 150px;
                line-height: 150px;
                cursor: pointer;
            }
            .img-up {
                text-align: center;
                border: 3px dashed $border-color4;
                border-radius: 10px;
                background-color: $bg1;
                overflow: hidden;
                img {
                    width: 320px;
                    height: 150px;
                    display: inline-block;
                }
                &.img-load-status {
                    width: 320px;
                    height: 150px;
                    border: none;
                    border-radius: 6px;
                }
            }
            .img-text {
                vertical-align: middle;
                font-size: $f20;
            }
            .el-icon-plus {
                vertical-align: middle;
                font-size: $f26;
                margin-right: 7px;
                color: inherit;
                font-weight: bold;
            }
        }
        .img-up-box {
            text-align: center;
            .img-up-list {
                vertical-align: middle;
                &:last-of-type {
                    margin-left: 24px;
                }
            }
        }
        .el-form-item__error {
            top: 90%;
            left: 50%;
            -webkit-transform: translateX(-50%);
            -moz-transform: translateX(-50%);
            transform: translateX(-50%);
        }
    }
}
</style>
